"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var Section_1 = __importDefault(require("../../app/components/Section"));
var AppMargins_1 = require("../../app/components/AppMargins");
var RotatingLinksGraphic_1 = __importDefault(require("./RotatingLinksGraphic"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return core_1.createStyles({
        pageHeightContainer: (_a = {
                display: 'flex',
                flexDirection: 'column'
            },
            _a[theme.breakpoints.up('md')] = {
                minHeight: "calc(100vh - " + (theme.spacing(4) + 108) + "px)",
            },
            _a[theme.breakpoints.up('lg')] = {
                minHeight: "calc(100vh - " + (theme.spacing(6) + 108) + "px)",
            },
            _a),
        container: (_b = {
                display: 'flex',
                flexDirection: 'column'
            },
            _b[theme.breakpoints.up('lg')] = {
                flexDirection: 'row',
            },
            _b),
        titleTextContainer: (_c = {
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '485px',
                marginBottom: theme.spacing(2)
            },
            _c[theme.breakpoints.up('sm')] = {
                minWidth: '500px',
            },
            _c['@media screen\\0'] = {
                display: 'inline',
            },
            _c),
        titleText: {
            fontWeight: 500,
        },
        subtitleText: {
            marginTop: theme.spacing(2),
            maxWidth: '404px',
        },
        rotatingLinksGraphic: (_d = {
                marginTop: theme.spacing(4),
                marginLeft: 'auto'
            },
            _d[theme.breakpoints.up('lg')] = {
                marginTop: theme.spacing(0),
            },
            _d),
        fillColor: (_e = {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                backgroundColor: theme.palette.primary.dark,
                maxHeight: '30vw',
                minHeight: '150px'
            },
            _e[theme.breakpoints.up('sm')] = {
                minHeight: '200px',
            },
            _e),
        ctaButton: {
            height: '52px',
            width: '25%',
            // Creates the half in colour-fill, half outside it effect.
            marginTop: 'calc(-52px / 2)',
            backgroundColor: '#9A9AFF',
            color: '#FFF',
            '&:hover': {
                backgroundColor: '#ca7126',
            },
        },
        signInTextContainer: (_f = {
                display: 'flex',
                flexGrow: 1,
                alignItems: 'center',
                justifyContent: 'center'
            },
            _f[theme.breakpoints.up('md')] = {
                justifyContent: 'flex-start',
            },
            _f[theme.breakpoints.up('lg')] = {
                marginTop: theme.spacing(4),
                alignItems: 'flex-start',
            },
            _f),
        signInText: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            color: theme.palette.secondary.light,
        },
        signInLink: {
            color: 'inherit',
            textDecoration: 'underline',
            '&:hover': {
                color: theme.palette.common.white,
            },
        },
    });
});
var LandingGraphicSliver = function () {
    var classes = useStyles();
    var useTopPaddingMultipler = function () {
        var theme = core_1.useTheme();
        var isMediumWidth = core_1.useMediaQuery(theme.breakpoints.up('md'));
        var isDesktopWidth = core_1.useMediaQuery(theme.breakpoints.up('lg'));
        if (isMediumWidth) {
            return 1;
        }
        if (isDesktopWidth) {
            return 1.75;
        }
        return 0.5;
    };
    return (react_1.default.createElement("div", { className: classes.pageHeightContainer },
        react_1.default.createElement(Section_1.default, { backgroundType: "light", topMultiplier: useTopPaddingMultipler(), bottomMultiplier: 0 },
            react_1.default.createElement("div", { className: classes.container },
                react_1.default.createElement("div", { className: classes.titleTextContainer },
                    react_1.default.createElement(core_1.Typography, { variant: "h1", color: "textPrimary", gutterBottom: true, className: classes.titleText },
                        react_1.default.createElement(react_i18next_1.Trans, null, "general.appCatchphrase.styled")),
                    react_1.default.createElement(core_1.Typography, { className: classes.subtitleText, variant: "subtitle1", color: "textPrimary" },
                        react_1.default.createElement(react_i18next_1.Trans, null, "general.appDescription.subtitle"))),
                react_1.default.createElement(AppMargins_1.IgnoreAppRightMargins, { className: classes.rotatingLinksGraphic },
                    react_1.default.createElement(RotatingLinksGraphic_1.default, null)))),
        react_1.default.createElement("div", { className: classes.fillColor },
            react_1.default.createElement(core_1.Hidden, { mdDown: true },
                react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
                    react_1.default.createElement(core_1.Button, { className: classes.ctaButton, variant: "contained", href: "/#/login" },
                        react_1.default.createElement(react_i18next_1.Trans, null, "general.appShortenYourLinksNow"),
                        ' '))),
            react_1.default.createElement("div", { className: classes.signInTextContainer },
                react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
                    react_1.default.createElement(core_1.Typography, { className: classes.signInText, variant: "caption" },
                        react_1.default.createElement(react_i18next_1.Trans, null, "general.appSignInPrompt"),
                        ' ',
                        react_1.default.createElement(core_1.Link, { className: classes.signInLink, href: "/#/login" },
                            react_1.default.createElement(react_i18next_1.Trans, null, "general.appSignIn"),
                            ' ')))))));
};
exports.default = LandingGraphicSliver;
